// utils/cnhFeedback.js
const moment = require("moment-timezone");

function formatDateBR(iso, tz = "America/Maceio") {
    return iso ? moment.tz(iso, tz).format("DD/MM/YYYY") : "data indisponível";
}

/**
 * Converte o resultado do verificaCNHParaProduto em:
 * - title: resumo principal
 * - lines: mensagens detalhadas (lista)
 * - severity: 'success' | 'warning' | 'danger'
 * - text: texto único pronto pra exibir (title + lines)
 */
function formatCnhFeedback(resultado) {
    const nome = resultado?.detalhes?.nome || "Condutor";
    const veic = resultado?.detalhes?.produtoDescricao || "o veículo";
    const catCond = resultado?.categoria?.condutor || "não definida";
    const catExig = resultado?.categoria?.exigida || "não definida";
    const val = resultado?.validade || {};
    const msgs = Array.isArray(resultado?.mensagens) ? [...resultado.mensagens] : [];

    // Monte mensagens de validade (expiring/expired/unknown)
    if (val.status === "expired") {
        msgs.unshift(`CNH vencida em ${formatDateBR(val.dataVencimento)} (${Math.abs(val.diasParaVencer)} dia(s) atrás).`);
    } else if (val.status === "expiring") {
        msgs.unshift(`CNH vence em ${val.diasParaVencer} dia(s) (${formatDateBR(val.dataVencimento)}).`);
    } else if (val.status === "unknown") {
        // só acrescenta se não veio do service
        if (!msgs.some((m) => m.toLowerCase().includes("validade da cnh"))) {
            msgs.unshift("Validade da CNH não informada.");
        }
    }

    // Categoria incompatível (se já foi avaliada e deu falso)
    if (resultado?.categoria && resultado.categoria.ok === false) {
        const m = `Categoria do condutor (${catCond}) não cobre a exigida pelo veículo (${catExig}).`;
        if (!msgs.includes(m)) msgs.push(m);
    }

    // Título + severidade
    let severity;
    let title;

    if (resultado.ok) {
        if (val.status === "expiring") {
            severity = "warning";
            title = `${nome} está apto(a) a conduzir ${veic}, mas a CNH vence em ${val.diasParaVencer} dia(s).`;
        } else {
            severity = "success";
            title = `${nome} está apto(a) a conduzir ${veic}.`;
        }
    } else {
        severity = val.status === "expired" ? "danger" : "warning";
        title = `${nome} não está apto(a) a conduzir ${veic}.`;
    }

    // Texto único (para usar em flash/toast)
    const text = [title, ...msgs].join(" ");

    return { title, lines: msgs, severity, text };
}

module.exports = { formatCnhFeedback };
